export const LOCALSTORAGE_STATE_KEY = 'DMS3_STATE';
export const LAST_ODOMETER = '<LAST_ODOMETER>';

export enum LANGUAGE_CODE {
    CZECH = 'cz',
	ENGLISH = 'en',
	MANDARIN = 'tw',
}

export enum LANGUAGE_ID {
    CZECH = 1,
	ENGLISH = 4,
	MANDARIN = 158,
}

export enum LANGUAGE_TYPE {
    CZECH = "Language_CZ",
	ENGLISH = "Language_EN",
	MANDARIN = "Language_TW",
}
export const VUE_APP_TENANT_HOST = [`${process.env.VUE_APP_TENANT_HOST}`];
